import { render, staticRenderFns } from "./LegalPerson.vue?vue&type=template&id=5a2742d5&scoped=true&"
import script from "./LegalPerson.vue?vue&type=script&lang=js&"
export * from "./LegalPerson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2742d5",
  null
  
)

export default component.exports